export const TaboolaSetupScript = `
  (function () {
    let loaderUrl, scriptType;
    window._taboolaOS = (function () {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var url = document.URL || document.location.href || window.location.href;
      var isWebView = /chromeless=true/i.test(url);
      if (isWebView)
          window.navigator._isWebView = true; // for now, set this for internal check in StateService.isWebview
      if (isWebView && /android/i.test(userAgent)) {
        window.taboolaMobilePubName = "krone-fanat-android";
        scriptType = "tb-loader-script";
        loaderUrl = "https://cdn.taboola.com/libtrc/krone-fanat-android/loader.js";
          return "Android";
      } else if (isWebView && /iPhone|iPad|iPod/i.test(userAgent)) {
        window.taboolaMobilePubName = "krone-fanat-ios";
        scriptType = "tb-loader-script";
        loaderUrl = "https://cdn.taboola.com/libtrc/krone-fanat-ios/loader.js";
        return "iOS";
      }
      scriptType = "tb_loader_script";
      loaderUrl = "https://cdn.taboola.com/libtrc/kroneat-fanat/loader.js";
      return "Web";
    })();

    window._taboola = window._taboola || [];
    !(function (e, f, u, i) {
      if (!document.getElementById(i)) {
        e.async = 1;
        e.src = u;
        e.id = i;
        f.parentNode.insertBefore(e, f);
      }
    })(
      document.createElement("script"),
      document.getElementsByTagName("script")[0],
      loaderUrl,
      scriptType
    );
  })();
`;

export const getTaboolaLoadArticleScript = (initialPageLoad: boolean, canonicalUrl: string) => `
  window._taboola = window._taboola || [];
  ${initialPageLoad ? '' : 'window._taboola.push({notify:"newPageLoad"});'}
  window._taboola.push({
    article: "auto",
    url: "${canonicalUrl}",
  });
  if (window._taboolaOS === "Android") {
    window._taboola.push({
      mode: "alternating-thumbnails-5",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
    window._taboola["mobile"] = [];
    window._taboola["mobile"].push({
      appid: "at.fan"
    });
  } else if (window._taboolaOS === "iOS") {
    window._taboola.push({
      mode: "alternating-thumbnails-6",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
    window._taboola["mobile"] = [];
    window._taboola["mobile"].push({
      appid: "at.fan"
    });
  } else {
    window._taboola.push({
      mode: "alternating-thumbnails-6",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    });
  }
  window._taboola.push({
    flush: true,
  });
`;
